export enum ProcedureInstanceStatus{
    NotStarted = 'Not Started',
    InProgress = 'In Progress',
    Completed = 'Completed',
    Canceled = 'Canceled',
}